import React from "react";
import Typography from "@material-ui/core/Typography";
import Styles from "../scss/notfound.module.scss";
import * as URLS from "../const/URL.const";
import { Button } from "@material-ui/core";
import setRedirectURLs from "../yoello-lib/modules/URL/setRedirectURLs";

const NotFound = () => {

  return (
    <div className={Styles.notfound}>
      <div className={Styles.logoWrapper}>
        <img src="../assets/images/yoello-icon.svg" alt="logo" width="60" />
        
        <img src="../assets/images/yoello-logo.svg" alt="yoello" width="80" />
      </div>
      <Typography variant="h4" data-component-name="NOT_FOUND">
        Looks like we're missing something :&#40;
      </Typography>

      <Button variant={"contained"} color={"primary"} href={URLS.HOME_URL} onClick={()=>{
        setRedirectURLs('')
      }}>
        Back To Homepage
      </Button>
    </div>
  );
};

export default NotFound;
